if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

					this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				//this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {

/*
=====================================
RENDER CART FIRST
=====================================
*/

this.cart.renderContents(response);


/*
=====================================
GET ORGANIC FIRST TOUCH
=====================================
*/

const organicFirstTouch =

	sessionStorage.getItem(
		"seo_organic_first_touch_page"
	);

/*
=====================================
ONLY SEND SEO EVENT
IF ORGANIC
=====================================
*/

if(organicFirstTouch) {

	/*
	=====================================
	PRODUCT INFO
	=====================================
	*/

	const variantId =

		this.form.querySelector(
			"[name=id]"
		).value;

	const quantityInput =

		this.form.querySelector(
			"[name=quantity]"
		);

	const quantity =

		quantityInput
		? parseInt(quantityInput.value)
		: 1;

	/*
	=====================================
	GET PRODUCT DATA
	=====================================
	*/

	const productTitle =

		document.querySelector(
			'.product__title'
		)?.innerText.trim() || null;

	const productHandle =
		meta?.product?.handle || null;

	const selectedVariant =

		meta?.product?.variants?.find(
			v => String(v.id) === String(variantId)
		);

	/*
	=====================================
	PRICE
	=====================================
	*/

	// current selling price

	const currentPrice =
		selectedVariant?.price
		? selectedVariant.price / 100
		: 0;

	/*
	=====================================
	COMPARE PRICE
	=====================================
	*/

	const comparePriceElement =

		document.querySelector(
			'.price__sale .price-item--regular'
		) ||

		document.querySelector(
			'.price-item--regular'
		);

	/*
	=====================================
	GET COMPARE PRICE TEXT
	=====================================
	*/

	const comparePriceText =
		comparePriceElement?.innerText || '';

	/*
	=====================================
	CLEAN PRICE
	=====================================
	*/

	const comparePriceClean =
		comparePriceText.replace(/[^\d]/g, '');

	/*
	=====================================
	FINAL COMPARE PRICE
	=====================================
	*/

	const comparePrice =
		comparePriceClean
		? Number(comparePriceClean)
		: currentPrice;

	/*
	=====================================
	DISCOUNT
	=====================================
	*/

	const discountPerItem =
		comparePrice - currentPrice;

	const discountPercentage =

		comparePrice > currentPrice

		? Math.round(
			(
				(comparePrice - currentPrice)
				/ comparePrice
			) * 100
		)

		: 0;

	const isDiscounted =
		comparePrice > currentPrice;

	/*
	=====================================
	SAVE PDP DATA
	=====================================
	*/

	sessionStorage.setItem(
		"seo_pdp_page",
		window.location.pathname
	);

	sessionStorage.setItem(
		"seo_organic_product_title",
		productTitle
	);

	sessionStorage.setItem(
		"seo_organic_product_handle",
		productHandle
	);

	/*
	=====================================
	SAVE ATC COUNT
	=====================================
	*/

	const currentAtcCount =
		Number(
			sessionStorage.getItem(
				"seo_organic_atc_count"
			) || 0
		);

	sessionStorage.setItem(
		"seo_organic_atc_count",
		currentAtcCount + quantity
	);

/*
=====================================
GET CART ATTRIBUTE
=====================================
*/

const seoOrganicAssistedProducts = JSON.parse(

	localStorage.getItem(
		"seo_organic_assisted_products"
	) || "[]"

);

	/*
	=====================================
	CHECK EXISTING PRODUCT
	=====================================
	*/

	const existingProductIndex =

		seoOrganicAssistedProducts.findIndex(

			item =>

				String(item.variant_id) ===
				String(variantId)

		);

	/*
	=====================================
	PRODUCT DATA
	=====================================
	*/

	const seoProductData = {

		variant_id:
			variantId,

		product_title:
			productTitle,

		product_handle:
			productHandle,

		current_price:
			currentPrice,

		compare_price:
			comparePrice,

		is_discounted:
			isDiscounted,

		quantity:
			quantity,

		first_touch_page:
			organicFirstTouch,

		pdp_page:
			window.location.pathname,

		added_at:
			new Date().toISOString()

	};

	/*
	=====================================
	UPDATE OR INSERT
	=====================================
	*/

	if(existingProductIndex > -1) {

		seoOrganicAssistedProducts[
	existingProductIndex
].quantity += quantity;

seoOrganicAssistedProducts[
	existingProductIndex
].added_at =
	new Date().toISOString();

	} else {

		seoOrganicAssistedProducts.push(
			seoProductData
		);

	}
/*
=====================================
SAVE TO LOCAL STORAGE
=====================================
*/

localStorage.setItem(

	"seo_organic_assisted_products",

	JSON.stringify(
		seoOrganicAssistedProducts
	)

);

console.log(
	"SEO ASSISTED PRODUCTS SAVED",
	seoOrganicAssistedProducts
);

/*
=====================================
SAVE TO CART ATTRIBUTE
=====================================
*/

fetch("/cart/update.js", {

	method: "POST",

	headers: {
		"Content-Type":
			"application/x-www-form-urlencoded"
	},

	body:

		"attributes[seo_organic_assisted_products]=" +

		encodeURIComponent(

			JSON.stringify(
				seoOrganicAssistedProducts
			)

		)

});

/*
=====================================
DATALAYER
=====================================
*/

window.dataLayer =
	window.dataLayer || [];

window.dataLayer.push({

	event:
		"seo_organic_assisted_atc",

	/*
	=================================
	FIRST TOUCH
	=================================
	*/

	seo_organic_first_touch_page:
		organicFirstTouch,

	/*
	=================================
	PAGE JOURNEY
	=================================
	*/

	seo_organic_page_before_pdp:

		sessionStorage.getItem(
			"seo_organic_page_before_pdp"
		),

	seo_organic_pdp_page:
		window.location.pathname,

	/*
	=================================
	PRODUCT
	=================================
	*/

	seo_organic_product_title:
		productTitle,

	seo_organic_product_handle:
		productHandle,

	seo_organic_variant_id:
		variantId,

	seo_organic_item_quantity:
		quantity,

	/*
	=================================
	BACKWARD COMPATIBILITY
	=================================
	*/

	seo_organic_item_price:
		currentPrice,

	seo_organic_atc_value:
		currentPrice * quantity,

	/*
	=================================
	CURRENT PRICE
	=================================
	*/

	seo_organic_current_price:
		currentPrice,

	seo_organic_current_value:
		currentPrice * quantity,

	/*
	=================================
	COMPARE PRICE
	=================================
	*/

	seo_organic_compare_price:
		comparePrice,

	seo_organic_compare_value:
		comparePrice * quantity,

	/*
	=================================
	DISCOUNT
	=================================
	*/

	seo_organic_discount_per_item:
		discountPerItem,

	seo_organic_discount_value:
		discountPerItem * quantity,

	seo_organic_discount_percentage:
		discountPercentage,

	seo_organic_is_discounted:
		isDiscounted

});

/*
=====================================
DEBUG
=====================================
*/

console.log(
	"SEO ORGANIC ADD TO CART",
	{
		productTitle,
		currentPrice,
		comparePrice,
		discountPerItem,
		discountPercentage,
		isDiscounted
	}
);

}


}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						//this.querySelector('.loading-overlay__spinner').classList.add('hidden');
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;
				
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
